<app-spinner></app-spinner>

<mat-toolbar
  class="bg-white border-bottom border-danger main-toolbar"
  style="padding: 0 60px; height: 100px; position: relative; z-index: 5"
>
  <div class="container-fluid">
    <div class="row p-0">
      <div class="col-md-12 p-0">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-auto logo-wrapper">
              <a class="cursor-pointer" (click)="onNavigate('/home')">
                <img
                  alt="smart media world"
                  width="150"
                  height="80"
                  ngSrc="{{env.CDN_URL}}/logo/smw{{logoSmartTomm}}-logo.png"
                  priority
                  class="logo-img"
                />
              </a>
            </div>
            @if (hasManagerOrEmployeeRole) {
              <div class="col-auto title ps-0">
                <div class="env-links">
                  <a href="https://stage-{{ client4SmwUrl }}.smart-media.world"
                     class="text-body-default text-decoration-none me-1"
                     [class.text-danger]="env.envName !== 'production'">Test</a>
                  |
                  <a href="https://{{ client4SmwUrl }}.smart-media.world"
                     class="text-body-default text-decoration-none ms-1"
                     [class.text-danger]="env.envName === 'production'">Live</a>
                </div>
              </div>
            }
            <div class="col text-end">
            <a
              href="javascript:void(0)"
              title="Logout"
              class="sidebar-link"
              (click)="logout()"
              >
              <fa-icon [icon]="faLogout" size="1x"></fa-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-toolbar>

<div style="display: flex; flex-direction: row">
  <app-sidenav [domain]="client4SmwUrl"/>
  <div #mainContent class="main-content bg-body">
    <router-outlet></router-outlet>
    <app-sidebar></app-sidebar>
    <footer class="main-footer">
      <a href="{{footerBaseUrl}}/kontakt/" target="_blank" rel="noopener noreferrer" title="Kontakt">Kontakt</a>
      <span class="footer-divider">|</span>
      <a href="{{footerBaseUrl}}/impressum/" target="_blank" rel="noopener noreferrer" title="Impressum">Impressum</a>
      <span class="footer-divider">|</span>
      <a href="{{footerBaseUrl}}/datenschutz/" target="_blank" rel="noopener noreferrer" title="Datenschutz">Datenschutz</a>
      <span class="footer-divider">|</span>
      <a href="{{footerBaseUrl}}/allgemeine-geschaeftsbedingungen-smart-media-world/" target="_blank" rel="noopener noreferrer" title="AGB">AGB</a>
    </footer>
  </div>
</div>
